import getters from "./formsGetters";
import actions from "./formsActions";
import mutations from "./formsMutations";
import state from "./formsState";
export default {
    state,
    getters,
    actions,
    mutations
};
